const routes = [
  {
    path: '/',
    name: 'index',
    redirect: { path: '/home' },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/layout/HomeView.vue'),
    redirect: { name: 'indexPage' },
    children: [
      {
        path: 'indexPage',
        name: 'indexPage',
        title: '首页',
        // redirect: { name: 'index' },
        component: () => import('@/views/index'),
        meta: {
          topMenuThem: 'transparent'
        }
      },
      {
        path: 'service',
        name: 'service',
        title: '交易信息',
        component: () => import('@/views/contract'),
        meta: {
          topMenuThem: '#ffffff'
        }

      },
      {
        path: 'supplier',
        name: 'supplier',
        title: '供应商管理',
        component: () => import('@/views/supplier'),

      },
      {
        path: 'news',
        name: 'news',
        title: '平台动态',
        component: () => import('@/views/news'),

      },
      {
        path: 'laws',
        name: 'laws',
        title: '政策法规',
        component: () => import('@/views/laws')
      },
      {
        path: 'businessProcessEntrance',
        name: 'businessProcessEntrance',
        title: '园区预约',
        component: () => import('@/views/businessProcessEntrance'),
        redirect: { name: 'parkingReservation' },
        children: [
          {
            path: 'charging',
            name: 'chargingReservation',
            title: '访客预约',
            component: () => import('@/views/businessProcessEntrance/parkingReservation'),
          },
          {
            path: 'parking',
            name: 'parkingReservation',
            title: '集卡预约',
            component: () => import('@/views/businessProcessEntrance/truckInfo'),
          },
          {
            path: 'supplier',
            name: 'supplierRegistration',
            title: '供应商注册',
            component: () => import('@/views/businessProcessEntrance/supplierRegistration'),
          }
        ]
      },
      {
        path: 'help',
        name: 'help',
        title: '操作帮助',
        component: () => import('@/views/help')
      },
      {
        path: 'ours',
        name: 'ours',
        title: '联系我们',
        component: () => import('@/views/ours')

      },

    ]
  }
]

export default routes
